import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './adminConsoleTheme.css';
import './darkReadableUi.css';
import './siteTheme.css';
import './premiumLounge.css';
import './bookingAnalyticsLounge.css';
import App from './App';
import { readStoredSiteThemeId, siteThemeHtmlClass, SITE_THEMES } from './theme/siteThemes';

(function bootstrapSiteTheme() {
  const id = readStoredSiteThemeId();
  const el = document.documentElement;
  SITE_THEMES.forEach((t) => el.classList.remove(siteThemeHtmlClass(t.id)));
  el.classList.add(siteThemeHtmlClass(id));
  el.dataset.pbSiteTheme = id;
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
